import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const FooterTaller = () => (
  <Box marginTop={6} paddingTop={3} borderTop={1} borderColor="divider" textAlign="center">
    <Typography variant="body2" color="textSecondary">
      © TNO Network 2026 | The Content Evolution
    </Typography>
    <Typography variant="caption" color="textSecondary" display="block" sx={{ fontStyle: 'italic', mt: 0.5 }}>
      Impulsando la ingeniería del contenido creativo.
    </Typography>
  </Box>
);

export default FooterTaller;
